<template>
  <div class="container">
    <div class="row">
      <div class="col-6">
        <div class="alert alert-success">
            You have successfully logged out!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount() {
    this.$auth.logout();
    sessionStorage.removeItem("user");
    setTimeout(() => {
      this.$router.push("/");
    }, 100);
  },
  mounted() {
    this.setTitle("Logged out");
  }
};
</script>
